<template>
  <v-container v-if="isLoading" fluid fill-width class="ma-0 pa-2">
    <v-row class="ma-0 pa-0">
      <v-col cols="12" class="ma-0 pa-0"> <loading-spinner /> </v-col>
    </v-row>
  </v-container>

  <v-container
    v-else
    fluid
    fill-width
    class="ma-0 pa-0"
    center="start"
    justify="start"
  >
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="pa-0 ma-0">
        <v-container
          fluid
          fill-width
          class="ma-0 pa-2"
          center="start"
          justify="start"
        >
          <v-app-bar app class="primary">
            <v-icon color="white" x-large>analytics</v-icon>
            <v-toolbar-title class="white--text pl-3"
              >Data Analytics
              <div class="subheading">
                Dataset:
                <v-tooltip bottom color="primary">
                  <template v-slot:activator="{ on: tooltip }">
                    <span v-on="{ ...tooltip }">{{ collection.label }}</span>
                  </template>
                  <span class="subtitle-1">{{
                    getCollectionDescription(collection)
                  }}</span>
                </v-tooltip>
              </div>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-chip
              v-if="useAutomatedAnalysisMode"
              color="yellow"
              text-color="black"
              class="mr-1"
              :disabled="!useAutomatedAnalysisMode"
              >Auto Mode ON</v-chip
            >
          </v-app-bar>

          <analysis-tracker
            class="pb-2"
            step="3"
            :substep="substep"
            :collection-id="collectionId"
          ></analysis-tracker>

          <v-container
            fluid
            class="pa-0 ma-0"
            style="
        background-color: white;
        width: 100%;"
          >
            <v-row class="ma-0 pa-0 py-1">
              <v-subheader
                class="subheading primary--text text--lighten-1 text-h6"
              >
                CHOOSE ANALYSIS TYPE:
              </v-subheader>

              <v-btn-toggle
                v-model="selectedMode"
                mandatory
                color="primary"
                background-color="transparent"
                class="ml-4 mb-2 pa-0"
              >
                <v-tooltip bottom color="primary">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      value="Predictor based"
                      :color="
                        selectedAnalysisMode == 'Predictor based'
                          ? 'primary'
                          : 'white'
                      "
                      style="border-color: gray !important;"
                      v-on="on"
                    >
                      <span
                        :style="
                          'color: ' +
                            (selectedAnalysisMode == 'Predictor based'
                              ? 'white'
                              : 'black') +
                            ' !important;'
                        "
                        >Predictor based</span
                      >
                    </v-btn>
                  </template>
                  <span class="subtitle-1 text-wrap"
                    >What's the difference between the outcomes of different
                    subject groups?</span
                  >
                </v-tooltip>

                <v-tooltip bottom color="primary">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      value="Outcome based"
                      :color="
                        selectedAnalysisMode == 'Predictor based'
                          ? 'white'
                          : 'primary'
                      "
                      style="border-color: gray !important;"
                      v-on="on"
                    >
                      <span
                        :style="
                          'color: ' +
                            (selectedAnalysisMode == 'Predictor based'
                              ? 'black'
                              : 'white') +
                            ' !important;'
                        "
                        >Outcome based</span
                      >
                    </v-btn>
                  </template>
                  <span class="subtitle-1 text-wrap"
                    >What baseline features can explain differences in a
                    selected outcome?</span
                  >
                </v-tooltip>
              </v-btn-toggle>
            </v-row>

            <!-- <v-row align="center" class="ma-0 ml-4">
              <span class="subtitle-1" v-if="selectedMode == 'Outcome based'">What's the difference between the subjects who do better and the subjects who do worse for a single chosen outcome variable?</span>
              <span class="subtitle-1" v-else>What's the difference between the outcomes of different subject groups?</span>
            </v-row> -->
          </v-container>

          <!-- define patterns -->
          <svg width="1" height="1" class="pa-0 ma-0">
            <defs>
              <pattern
                v-for="(p, index) in patterns"
                :id="p['id']"
                :key="'dep-' + index"
                patternUnits="userSpaceOnUse"
                width="25"
                height="25"
                :patternTransform="p['transform']"
              >
                <g v-html="p['pattern']" />
              </pattern>
            </defs>
          </svg>

          <v-container fluid fill-width class="ma-0 pa-0 pt-0">
            <v-row class="ma-0 pa-0 pt-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-sheet color="white" height="100%" class="rounded-lg shadow">
                  <v-container fluid fill-width class="ma-0 pa-0">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12" class="ma-0 pa-0">
                        <cohort-table
                          ref="cohortTable"
                          title="ANALYZE STUDY GROUPS"
                          :cohorts="selectedCohortsInMode"
                          :select-cohorts="visibleCohorts"
                          :disable-pagination="true"
                          show-select
                          show-colors
                          report-max-selected-overlap
                          report-empty-cohorts
                          checkbox-tooltip="Check to include this study group in the next analysis."
                          @selectedCohorts="updateVisibleCohorts"
                          @selectedEmptyCohorts="updateEmptyCohorts"
                          @cohortColorChange="updateCohortColor"
                        />
                      </v-col>
                    </v-row>

                    <v-row class="ma-0 pa-0">
                      <v-col cols="12" class="ma-0 pa-0">
                        <v-container v-if="collection.is_longitudinal" fluid>
                          <span
                            class="primary--text subtitle-1 font-weight-bold mb-1"
                            >Analysis Measure:</span
                          >
                          <v-radio-group
                            v-if="selectedAnalysisMode == 'Predictor based'"
                            v-model="selectedComparisonMeasure"
                            hide-details
                            row
                            dense
                            class="ma-0 pa-0"
                          >
                            <v-radio
                              v-for="m in comparisonMeasures"
                              :key="m.value"
                              :label="m.label"
                              :value="m"
                            ></v-radio>
                          </v-radio-group>
                          <v-radio-group
                            v-else
                            v-model="selectedComparisonMeasure"
                            hide-details
                            row
                            dense
                            class="ma-0 pa-0"
                          >
                            <v-radio
                              v-for="m in [comparisonMeasures[1]]"
                              :key="m.value"
                              :label="m.label"
                              :value="m"
                            ></v-radio>
                          </v-radio-group>
                        </v-container>

                        <v-btn
                          class="primary text--white ma-0 px-2 py-0 mx-3 mb-2"
                          :disabled="
                            collection.user_id != user.id ||
                              !twoOrMoreCohortsSelected ||
                              selectedEmptyCohorts.length > 0 ||
                              historyLoading
                          "
                          @click="analyzeCohortList(visibleCohorts)"
                          ><v-icon large class="pr-2" color="white"
                            >analytics</v-icon
                          >
                          Analyze
                          {{
                            twoOrMoreCohortsSelected
                              ? visibleCohorts.length
                              : ''
                          }}
                          Selected Study Groups</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-0 pt-2" min-height="400px">
              <v-col
                v-if="historyLoading"
                cols="12"
                class="ma-0 py-6 white"
                justify="center"
              >
                <span class="subheading primary--text text--lighten-4 text-h6">
                  LOADING SAVED ANALYSES...
                </span>
              </v-col>
              <v-col v-else cols="12" class="ma-0 pa-0">
                <analysis-list
                  :analyses="analyses"
                  @deleteAnalysis="deleteAnalysis"
                  @refreshAnalysis="refreshAnalysis"
                  @cohortColorChange="updateCohortColor"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-col>
    </v-row>

    <v-dialog v-model="aaDialog" persistent scrollable max-width="40%">
      <v-card class="rounded-lg" style="border: 3px solid #3f51b5;">
        <v-card-title color="white" class="ma-0 pa-2" primary-title>
          <span class="primary--text text--darken-3 title"
            >Automated Analysis Mode: Run Analyses</span
          >
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="py-4">
          <v-list>
            <v-list-item
              v-for="(s, i) in aaSteps"
              :key="`prog-${i}`"
              :disabled="i > aaProgress"
            >
              <v-list-item-content>
                {{ s.title }}
                <v-list
                  v-if="s.title == 'Running analyses' && aaAnalyses.length > 0"
                >
                  <v-list-item v-for="(c, j) in aaAnalyses" :key="`an-${j}`">
                    <v-list-item-content> {{ c }} </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-list-item-content>
              <v-list-item-avatar>
                <v-icon v-if="i < aaProgress">done</v-icon>
              </v-list-item-avatar>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions v-if="aaDialogOKButton">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="aaProgress < 3"
            class="primary white--text ma-0 px-2 mx-2"
            @click="aaDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import { state as authState } from '@/store/modules/auth/types';
import { actions, state } from '@/store/modules/dataExplorer/types';
import AnalysisList from '@/components/DataExplorer/AnalysisList.vue';
import AnalysisTracker from '@/components/common/AnalysisTracker.vue';
import CohortTable from '@/components/common/CohortTable.vue';
import { actions as collaborationActions } from '@/store/modules/collaboration/types';
import { getCollectionDescription } from '@/utils/helpers';
import { colors, assignStudyGroupColors } from '@/utils/colors';
import { patterns } from '@/utils/patterns';
import logEvent from '@/utils/logging';

const COMPARISON_MEASURES = [
  {
    label: 'Change',
    value: 'change',
    descr: 'First visit - Last visit change',
  },
  {
    label: 'First Visit',
    value: 'firstVisit',
    descr: 'First visit measurements',
  },
  {
    label: 'Last Visit',
    value: 'lastVisit',
    descr: 'Last visit measurements',
  },
];

// defaults shared across all components within an analysis
const ANALYSIS_DEFAULTS = {
  showTooltips: false,
  showPercentages: true,
  showMeanValues: true,
  showOutliers: false,
  showSubjectCounts: true,
};

var aaSteps = [
  { title: 'Loading Study Groups' },
  { title: 'Running analyses' },
  { title: 'Done' },
];

export default {
  components: {
    AnalysisList,
    AnalysisTracker,
    CohortTable,
  },
  props: {
    collectionId: {
      type: Number,
      required: true,
    },
    // comma-delimited list of cohort ids to display
    cohortIds: {
      type: String,
      required: false,
      default: undefined,
    },
    // comma-delimited list of cohort ids to select
    visibleCohortIds: {
      type: String,
      required: false,
      default: undefined,
    },
    aaPredictors: {
      type: Array,
      default: () => [],
    },
    aaOutputs: {
      type: Array,
      default: () => [],
    },
    scrollTo: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      historyLoading: false,
      selectedCohorts: [],
      selectedCohortsInMode: [],
      selectedEmptyCohorts: [],
      expandAnalytics: true,
      colors: colors,
      patterns: patterns,
      getCollectionDescription: getCollectionDescription,
      analyses: [],
      comparisonMeasures: COMPARISON_MEASURES,
      selectedComparisonMeasure: COMPARISON_MEASURES[2],
      aaDialog: false,
      aaDialogOKButton: false,
      aaProgress: 0,
      analysisNum: 0,
      aaLastUpdate: null,
      aaMinStepTime: 1,
      aaSteps: aaSteps,
      aaAnalyses: [],
      cohort_ids: [],
      analysis_defaults: ANALYSIS_DEFAULTS,
      selectedMode: 'Predictor based',
    };
  },
  computed: {
    ...mapState('auth', {
      user: authState.USER,
    }),
    ...mapState('dataExplorer', {
      cohorts: state.COHORTS,
      data: state.DATA,
      detailedView: state.DETAILED_VIEW,
      visibleCohorts: state.VISIBLE_COHORTS,
      collection: state.COLLECTION,
      selectedAnalysisMode: state.SELECTED_ANALYSIS_MODE,
    }),
    collectionCohorts() {
      var cc = [];
      var collectionId = this.collection.id;
      this.cohorts.forEach(c => {
        if (c.collection_id == collectionId) {
          cc.unshift(c);
        }
      });
      return cc;
    },
    twoOrMoreCohortsSelected() {
      return this.visibleCohorts.length >= 2;
    },
    substep() {
      var ss = this.visibleCohorts.length > 1 ? '3.2' : '3.1';
      return ss;
    },
    useAutomatedAnalysisMode() {
      return this.aaPredictors.length + this.aaOutputs.length > 0;
    },
  },
  watch: {
    'collection.id': {
      handler(id) {
        if (id) {
          this.$store.dispatch(
            'collaboration/' + collaborationActions.SET_ACTIVE_COLLECTION,
            this.collection
          );
        }
      },
      immediate: true,
    },
    scrollTo(num) {
      if (num) this.scrollToAnalysis(num);
    },
    selectedMode() {
      this.setAnalysisMode(this.selectedMode);

      if (this.selectedAnalysisMode == 'Predictor based') {
        this.selectedComparisonMeasure = COMPARISON_MEASURES[2];
      } else {
        this.selectedComparisonMeasure = COMPARISON_MEASURES[1];
      }

      let scc = [];
      this.selectedCohorts.forEach(c => {
        if (
          this.selectedAnalysisMode == 'Outcome based' &&
          c.label.startsWith('[O]_')
        ) {
          scc.unshift(c);
        } else if (
          this.selectedAnalysisMode == 'Predictor based' &&
          !c.label.startsWith('[O]_')
        ) {
          scc.unshift(c);
        }
      });
      scc = [...scc].sort((x, y) => y['id'] - x['id']);
      this.selectedCohortsInMode = scc;
    },
  },
  async created() {
    this.isLoading = true;
    this.historyLoading = true;
    if (this.useAutomatedAnalysisMode) {
      this.aaDialog = true;
      this.aaProgress = 0;
    }
    await this.clearData();
    await this.fetchCollection(this.collectionId);
    await this.fetchData();
    await this.fetchCohorts(this.collectionId);
    this.selectedMode = this.selectedAnalysisMode;
    if (this.selectedAnalysisMode == 'Predictor based') {
      this.selectedComparisonMeasure = COMPARISON_MEASURES[2];
    } else {
      this.selectedComparisonMeasure = COMPARISON_MEASURES[1];
    }

    // determine selected cohorts and assign colors
    var selectedCohorts = this.getCohortsFromIdList(this.cohortIds);
    // if nothing selected then include all cohorts
    if (!selectedCohorts || selectedCohorts.length === 0) {
      selectedCohorts = this.collectionCohorts;
    }
    var scc = [...selectedCohorts].sort((x, y) => y['id'] - x['id']);
    this.selectedCohorts = scc;

    scc = [];
    this.selectedCohorts.forEach(c => {
      if (
        this.selectedAnalysisMode == 'Outcome based' &&
        c.label.startsWith('[O]_')
      ) {
        scc.unshift(c);
      } else if (
        this.selectedAnalysisMode == 'Predictor based' &&
        !c.label.startsWith('[O]_')
      ) {
        scc.unshift(c);
      }
    });
    scc = [...scc].sort((x, y) => y['id'] - x['id']);
    this.selectedCohortsInMode = scc;

    // assign colors
    let cohortUpdates = assignStudyGroupColors(
      this.selectedCohorts,
      this.collectionId
    );
    if (cohortUpdates.length > 0) this.saveCohortDisplayPrefs(cohortUpdates);

    // preselect cohorts in visibleCohortIds
    var vc = this.getCohortsFromIdList(this.visibleCohortIds);
    this.setVisibleCohorts(vc);
    this.isLoading = false;

    if (this.useAutomatedAnalysisMode) {
      this.doAutomatedAnalysis();
    }

    const { data } = await axios.get(
      `/api/collections/` + this.collection.id + `/analyses`
    );
    data.analyses.forEach(ana => {
      ana.version = 1;
      var sortedCohorts = this.selectedCohorts.filter(d =>
        ana.cohort_ids.split(',').includes(String(d.id))
      );
      // infer analysis mode. don't read from state
      var selectedAnalysisMode =
        sortedCohorts.length > 0 && sortedCohorts[0].label.startsWith('[O]_')
          ? 'Outcome based'
          : 'Predictor based';

      const varsAdded = {};
      const inputVariables = [];
      const outputVariables = [];

      sortedCohorts.forEach(c => {
        const inputVars = c.input_variables;
        inputVars.forEach(iv => {
          if (iv.subject_ontology != null) {
            const { id } = iv.subject_ontology;
            if (!(id in varsAdded)) {
              varsAdded[id] = 1;
              inputVariables.push(iv.subject_ontology);
            }
          } else {
            const { id } = iv.observation_ontology;
            var key = id + ':' + iv.dimension_label;
            if (!(key in varsAdded)) {
              varsAdded[key] = 1;
              inputVariables.push(iv);
            }
          }
        });
        const outputVars = c.output_variables;
        outputVars.forEach(ov => {
          if (ov.observation_ontology != null) {
            const { id } = ov.observation_ontology;
            if (!(id in varsAdded)) {
              varsAdded[id] = 1;
              ov.observation_ontology.is_longitudinal = this.collection.is_longitudinal;
              outputVariables.push(ov.observation_ontology);
            }
          } else if (
            selectedAnalysisMode == 'Outcome based' &&
            ov.subject_ontology != null
          ) {
            const { id } = ov.subject_ontology;
            if (!(id in varsAdded)) {
              varsAdded[id] = 1;
              outputVariables.push(ov.subject_ontology);
            }
          }
        });
      });

      const CMD = {};
      COMPARISON_MEASURES.forEach(cm => {
        CMD[cm.value] = cm;
      });
      let cm = CMD[ana.analysis_measure];
      let analysis = {
        index: ana.analysis_num,
        version: ana.version,
        cohorts: sortedCohorts,
        predictorVariables: inputVariables,
        outcomeVariables: outputVariables,
        pvals: ana.results,
        collection: this.collection,
        ...this.analysis_defaults,
      };
      analysis.input = {
        numGroups: this.selectedCohorts.length,
        groups: sortedCohorts,
        outputVariables: outputVariables,
        comparisonField: ana.analysis_measure,
        comparisonFieldDescr: cm.label,
        comparisonFieldLongDescr: cm.descr,
        collection_id: this.collectionId,
        cohort_ids: ana.cohort_ids,
        analysis_num: ana.analysis_num,
      };
      analysis.statusTime = ana.last_modified;
      analysis.status = 'Completed';
      this.logAnalysisStatusChange(analysis);
      this.analyses.push(analysis);
    });
    this.analyses.reverse();
    this.historyLoading = false;
    if (this.scrollTo) {
      this.$nextTick(() => this.scrollToAnalysis(this.scrollTo));
    }
  },
  methods: {
    ...mapActions('dataExplorer', {
      analyzeCohorts: actions.ANALYZE_COHORTS,
      fetchCohorts: actions.FETCH_COHORTS,
      fetchCollection: actions.FETCH_COLLECTION,
      clearData: actions.CLEAR_DATA,
      fetchData: actions.FETCH_DATA,
      setDetailedView: actions.SET_DETAILED_VIEW,
      setVisibleCohorts: actions.SET_VISIBLE_COHORTS,
      saveCohortDisplayPrefs: actions.SAVE_COHORT_DISPLAY_PREFS,
      setAnalysisMode: actions.SET_ANALYSIS_MODE,
    }),
    scrollToAnalysis(num) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const el = document.getElementById(`analysis-${num}-1`);
          if (!el) return;
          const offset = this.$vuetify.application.top + 8;
          el.style.scrollMarginTop = `${offset}px`;
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    },
    variableSelected(nv) {
      this.setDetailedView(nv);
    },
    analyticsExpandClicked(nv) {
      this.expandAnalytics = nv;
    },
    updateVisibleCohorts(vc) {
      this.setVisibleCohorts(vc);
    },
    updateEmptyCohorts(ec) {
      this.selectedEmptyCohorts = ec;
    },
    updateCohortColorInArray(a, cc) {
      let i = 0;
      let cnum = null;
      a.forEach(c => {
        if (c.id == cc['cohort'].id) {
          cnum = i;
        }
        i += 1;
      });
      if (cnum != null) {
        a[cnum]['color'] = cc['color'];
        if ('pattern' in cc) {
          a[cnum]['pattern'] = cc['pattern'];
        }
        // force update
        a.splice(cnum, 1, a[cnum]);
      }
    },
    updateCohortColor(cc) {
      this.updateCohortColorInArray(this.selectedCohorts, cc);
      let self = this;
      this.analyses.forEach(an => {
        self.updateCohortColorInArray(an.cohorts, cc);
      });
    },
    getCohortsFromIdList(idList) {
      var sc = [];
      if (typeof idList !== 'undefined' && idList !== '') {
        const cids = {};
        var collectionId = this.collection.id;
        idList.split(',').forEach(c => {
          cids[c] = 1;
        });
        this.cohorts.forEach(c => {
          if (c.collection_id === collectionId && c.id in cids) {
            sc.push(c);
          }
        });
      }
      return sc;
    },
    logAnalysisStatusChange(analysis) {
      logEvent(
        this.$gtag,
        null,
        null,
        'analysis_status_change',
        'analysis',
        'analysis ' + analysis.index + ' ' + analysis.status
      );
    },
    // analysis_index - optional: specifies an analysis to refresh if not null
    analyzeCohortList(cohorts, analysis_index, analysis_version) {
      var sortedCohorts = [...cohorts].sort((x, y) => y['id'] - x['id']);
      // infer analysis mode. don't read from state
      var selectedAnalysisMode =
        sortedCohorts.length > 0 && sortedCohorts[0].label.startsWith('[O]_')
          ? 'Outcome based'
          : 'Predictor based';

      // union cohort outcome variables
      const varsAdded = {};
      const inputVariables = [];
      const outputVariables = [];

      sortedCohorts.forEach(c => {
        const inputVars = c.input_variables;
        inputVars.forEach(iv => {
          if (iv.subject_ontology != null) {
            const { id } = iv.subject_ontology;
            if (!(id in varsAdded)) {
              varsAdded[id] = 1;
              inputVariables.push(iv.subject_ontology);
            }
          } else {
            const { id } = iv.observation_ontology;
            var key = id + ':' + iv.dimension_label;
            if (!(key in varsAdded)) {
              varsAdded[key] = 1;
              inputVariables.push(iv);
            }
          }
        });
        const outputVars = c.output_variables;
        outputVars.forEach(ov => {
          if (ov.observation_ontology != null) {
            const { id } = ov.observation_ontology;
            if (!(id in varsAdded)) {
              varsAdded[id] = 1;
              ov.observation_ontology.is_longitudinal = this.collection.is_longitudinal;
              outputVariables.push(ov.observation_ontology);
            }
          } else if (
            selectedAnalysisMode == 'Outcome based' &&
            ov.subject_ontology != null
          ) {
            const { id } = ov.subject_ontology;
            if (!(id in varsAdded)) {
              varsAdded[id] = 1;
              outputVariables.push(ov.subject_ontology);
            }
          }
        });
      });

      // run analysis
      let index = 0;
      if (analysis_index != null) {
        index = analysis_index;
      } else {
        this.analysisNum = this.analysisNum - 1;
        index = this.analysisNum;
      }
      const version = analysis_index == null ? 1 : analysis_version + 1;
      var analysis = {
        index: index,
        version: version,
        cohorts: sortedCohorts,
        predictorVariables: inputVariables,
        outcomeVariables: outputVariables,
        pvals: null,
        collection: this.collection,
        ...this.analysis_defaults,
      };
      // create group of samples for each cohort:
      const groups = [];
      sortedCohorts.forEach(c => {
        if (c.collection_id === this.collection.id) {
          const subjids = [];
          c.subject_ids.forEach(sid => {
            subjids[sid] = 1;
          });
          const cohortData = this.data.filter(d => d.subject_id in subjids);
          groups.push(cohortData);
        }
      });
      const numGroups = groups.length;
      const comparisonField = this.selectedComparisonMeasure.value;
      const comparisonFieldDescr = this.selectedComparisonMeasure.label;
      const comparisonFieldLongDescr = this.selectedComparisonMeasure.descr;
      const collection_id = this.collection.id;
      const cohort_ids = cohorts.map(c => c.id).join(',');
      const analysis_num = analysis_index == null ? -1 : analysis_index;

      analysis.input = {
        numGroups,
        groups,
        outputVariables,
        comparisonField,
        comparisonFieldDescr,
        comparisonFieldLongDescr,
        collection_id,
        cohort_ids,
        analysis_num,
      };

      const action =
        analysis_index == null ? 'new_analysis' : 'refresh_analysis';

      logEvent(
        this.$gtag,
        null,
        null,
        action,
        'analysis',
        'analysis ' +
          analysis.index +
          ' measure=' +
          analysis.input.comparisonFieldDescr +
          ' cohorts=' +
          analysis.cohorts.map(c => c.label).join(',')
      );

      analysis.status = analysis_index == null ? 'Running' : 'Refreshing';
      analysis.statusTime = new Date().getTime();
      this.logAnalysisStatusChange(analysis);
      var vm = this;

      axios
        .post(`/api/compute-anova`, analysis.input)
        .then(function(response) {
          const { data } = response;
          analysis.pvals = data.pvals;
          analysis.index = data.analysis_num;
          analysis.statusTime = new Date().getTime();
          analysis.status = 'Completed';
          vm.logAnalysisStatusChange(analysis);
        })
        .catch(function(err) {
          analysis.statusTime = new Date().getTime();
          analysis.error = err;
          analysis.status = 'Failed';
          vm.logAnalysisStatusChange(analysis);
        });

      // run new analysis
      if (analysis_index == null) {
        this.analyses.unshift(analysis);
        // clear cohort selection
        this.$refs.cohortTable.deselectAll();
      }
      // refresh existing analysis
      else {
        for (var i = 0; i < this.analyses.length; ++i) {
          if (this.analyses[i].index == analysis_index) {
            // force update
            this.analyses.splice(i, 1, analysis);
          }
        }
      }
    },
    deleteAnalysis(anum) {
      const analysis_num = this.analyses[anum].index;
      const collection_id = this.collection.id;
      let de = this;
      axios
        .delete(
          `/api/collections/` + collection_id + `/analyses/` + analysis_num
        )
        .then(({ status }) => {
          if (status == 200) {
            var new_analyses = [...de.analyses];
            new_analyses.splice(anum, 1);
            de.analyses = new_analyses;
          }
        });
    },
    refreshAnalysis(anum) {
      const analysis = this.analyses[anum];
      analysis.pvals = null;
      analysis.status = 'Refreshing';
      this.analyzeCohortList(
        analysis.cohorts,
        analysis.index,
        analysis.version
      );
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async updateAutomatedAnalysisProgress(progress) {
      var ts = Date.now();
      if (this.aaLastUpdate == null) {
        this.aaProgress = progress;
      } else {
        var diff = (ts - this.aaLastUpdate) / 1000.0;
        if (diff < this.aaMinStepTime) {
          var remaining = this.aaMinStepTime - diff;
          await this.sleep(remaining * 1000);
        }
        this.aaProgress = progress;
      }
      this.aaLastUpdate = Date.now();
    },
    async doAutomatedAnalysis() {
      await this.updateAutomatedAnalysisProgress(1);

      // group cohorts by input var
      var ivc = {};
      var ct = this.$refs.cohortTable;
      let get_ont_abbrev = function(v) {
        if (v.subject_ontology) {
          return v.subject_ontology.abbreviation;
        } else {
          return v.observation_ontology.abbreviation;
        }
      };

      ct.cohorts.forEach(c => {
        var ivs = c.input_variables.filter(
          v =>
            c.label.startsWith(get_ont_abbrev(v) + ' ') ||
            c.label.startsWith(get_ont_abbrev(v) + '|')
        );
        if (ivs.length == 1) {
          var key = get_ont_abbrev(ivs[0]);
          if (!(key in ivc)) {
            ivc[key] = [];
          }
          ivc[key].push(c);
        }
      });

      var keys = Object.keys(ivc);
      for (var i = 0; i < keys.length; ++i) {
        var cohorts = ivc[keys[i]];
        this.aaAnalyses.push(
          keys[i] + ' - ' + cohorts.length + ' study groups'
        );
        this.analyzeCohortList(cohorts);
        await this.sleep(this.aaMinStepTime * 1000);
      }

      await this.updateAutomatedAnalysisProgress(2);
      await this.updateAutomatedAnalysisProgress(3);
      if (!this.aaDialogOKButton) {
        await this.sleep(2000);
        this.aaDialog = false;
      }
    },
  },
};
</script>

<style scoped></style>
